import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../../Redux/modalSlice';
import './ModalCards.css';

export const ModalCards = () => {
  const dispatch = useDispatch();
  const { isOpen, info } = useSelector((state) => state.modal);

  const closeModalHandler = () => {
    dispatch(closeModal());
  };

  useEffect(() => {
    if (!isOpen) {
      document.body.style.overflow = '';
      return undefined;
    }

    // Block scroll when modal is open (A-03)
    document.body.style.overflow = 'hidden';

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        dispatch(closeModal());
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [dispatch, isOpen]);

  const colorIf = (skill) => {
    switch (skill) {
      case '#Reactnative': return { color: '#61dafb' };
      case '#Firebase': return { color: '#FFCA28' };
      case '#Javascript': return { color: '#F7DF1E' };
      case '#Tailwind': return { color: '#38BDF8' };
      case '#Python': return { color: '#306998' };
      case '#Node.js': return { color: '#68A063' };
      case '#Css': return { color: '#264de4' };
      case '#MailSTP': return { color: '#8E44AD' };
      case '#SAPBuinessOne': return { color: '#af3131' };
      default: return { color: '#61dafb' };
    }
  };

  return (
    <div
      className={`modal-overlay ${isOpen ? 'open' : ''}`}
      onClick={closeModalHandler}
      role="presentation"
    >
      {isOpen && (
        <div
          className="container-modal-card"
          role="dialog"
          aria-modal="true"
          aria-label={`Detalle del proyecto ${info?.work ?? ''}`}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            className="modal-close"
            onClick={closeModalHandler}
            aria-label="Cerrar modal"
          >
            &times;
          </button>

          <div className="modal-text-content">
            <div className="modal-header">
              <p className="modal-eyebrow">Proyecto</p>
              <h3>{info?.work}</h3>
            </div>
            <div className="modal-skill-group">
              {info?.skills?.map((skill, index) => (
                <span key={index} className="card-skill-tag" style={colorIf(skill)}>{skill}</span>
              ))}
            </div>
            <p className="modal-description">{info?.description}</p>
            <div className="modal-actions">
              {info?.linkUrl && (
                <a
                  className="modal-link"
                  href={info.linkUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ver sitio
                </a>
              )}
              <button
                type="button"
                className="modal-cta"
                onClick={closeModalHandler}
              >
                Cerrar
              </button>
            </div>
          </div>
          <div className="modal-img-content">
            {info?.img?.map((image, index) => (
              <img key={index} src={image} alt={`${info?.work}-${index}`} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
